import { Component, OnInit } from '@angular/core';
declare let refreshCarousel: any;
@Component({
  selector: 'app-event-management-services',
  templateUrl: './event-management-services.component.html'
})
export class EventManagementServicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    setTimeout(function () {
      try {
        refreshCarousel();
      } catch (e) {
        console.log(e.message);
      }

    }, 2000);
  }

}
